
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"36","height":"36","rx":"8","fill":"#1937A3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.3 9.7a.9.9 0 01.853.616L20.7 23.954l1.846-5.538a.9.9 0 01.854-.616H27a.9.9 0 110 1.8h-2.952l-2.495 7.485a.9.9 0 01-1.707 0L15.3 13.446l-1.847 5.539a.9.9 0 01-.853.615H9a.9.9 0 110-1.8h2.95l2.496-7.484A.9.9 0 0115.3 9.7z","fill":"#fff"}})])
          )
        }
      }
    